import React, {useState} from 'react';
import PropTypes from 'prop-types';

// MUI Components
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemAvatar';
import Divider from '@mui/material/Divider';

import {WhiteButton, WhiteAvatar, PrimaryAvatar} from './styled';
import {redirectToHealthHubTools, handleLogout} from 'contexts/openIdConnect';

//Constants
import {
  PROFILE_INFO_WHITE_BUTTON_TEST_ID,
  PROFILE_INFO_POPOVER_TEST_ID,
  PROFILE_INFO_COMPONENT_TEST_ID
} from 'testidConstants.js';

// REDUX
import {connect} from 'react-redux';
import {configSelector} from 'redux/slices/appSlice';

const ProfileInfo = ({userInfo, config}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpened, setIsOpened] = useState(false);
  const initials = userInfo?.given_name ? userInfo?.given_name.substring(0, 1).toLocaleUpperCase() : '';

  const handleOpenProfileInfo = (event) => {
    setAnchorEl(event.currentTarget);
    setIsOpened(true);
  };

  const handleClose = () => {
    setIsOpened(false);
    setAnchorEl(null);
  };

  return (
    <div data-testid={PROFILE_INFO_COMPONENT_TEST_ID}>
      <WhiteButton onClick={handleOpenProfileInfo} data-testid={PROFILE_INFO_WHITE_BUTTON_TEST_ID}>
        {initials ? <WhiteAvatar>{initials}</WhiteAvatar> : <AccountCircleIcon />}
      </WhiteButton>
      <Popover
        open={isOpened}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        data-testid={PROFILE_INFO_POPOVER_TEST_ID}
      >
        <div style={{padding: 24}}>
          {initials && (
            <>
              <ListItem style={{padding: 0}}>
                <ListItemIcon>
                  <PrimaryAvatar>{initials}</PrimaryAvatar>
                </ListItemIcon>
                <ListItemText primary={userInfo?.given_name} />
              </ListItem>
              <Divider light style={{margin: '16px 0'}} />
            </>
          )}
          <Button onClick={() => handleLogout(config.flagshipBaseUrl)} variant="contained" color="primary">
            Logout
          </Button>
          <Button
            onClick={() => redirectToHealthHubTools(config.flagshipBaseUrl)}
            style={{marginLeft: 16}}
            color="primary"
          >
            Home
            <OpenInNewIcon style={{width: 18, marginLeft: 8}} />
          </Button>
        </div>
      </Popover>
    </div>
  );
};

ProfileInfo.propTypes = {
  userInfo: PropTypes.object,
  config: PropTypes.object
};

const mapStateToProps = (state) => ({
  config: configSelector(state)
});

export default connect(mapStateToProps)(ProfileInfo);
